module.exports = __webpack_public_path__ + "img/prdays-logo-white-2023.cf35a86c.svg";